// extracted by mini-css-extract-plugin
export default {"button":"Button_button__Hwdg5","normal":"Button_normal__U8lkk","big":"Button_big__XrI9l"};